import { InteractiveMarker } from "common/Map/InteractiveMarker";
import { poiIcons } from "common/Map/Marker/poiIcons";
import { NativeClickImg } from "common/Map/NativeClickImg";
import { showGallery } from "features/gallery/showGallery";
import { photoMilli } from "lib/urlHelpers";
import PropTypes from "prop-types";
import React from "react";
import styles from "./POI.scss";

const genericIcon = poiIcons["poi-generic"];

export const getIcon = (poiType) => Object.values(poiIcons).find((i) => i.poiType === poiType) || genericIcon;

export const POI = (props) => {
  const { id, poiType, name, description, url, lat, lng, photos, photoIds } = props;

  const poiIcon = getIcon(poiType);

  const iconHeight = poiIcon.iconSize[1];
  const popupOffset = [0, -5 - iconHeight];

  const hoveredPopup = (
    <div className={styles.poiPopup}>
      <h4>{name}</h4>
      {description && <p>{description}</p>}
    </div>
  );
  const focusedPopup = (
    <div className={styles.poiPopup}>
      <h4>{name}</h4>
      {description && <p>{description}</p>}
      {url && (
        <p>
          <a href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </a>
        </p>
      )}
      <Photogrid pids={photoIds} photos={photos} />
    </div>
  );

  return (
    <InteractiveMarker
      id={`poi-v3-${id}`}
      position={{ lat, lng }}
      icon={poiIcon}
      popupOffset={popupOffset}
      hoveredPopup={hoveredPopup}
      focusedPopup={focusedPopup}
    />
  );
};

POI.propTypes = {
  id: PropTypes.any.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  poiType: PropTypes.number.isRequired,
};

// translation layer for compressed POI format
export const POIv2 = ({ poi, photos }) => (
  <POI
    id={poi.id}
    poiType={poi.t}
    name={poi.n}
    description={poi.d}
    url={poi.url}
    lat={poi.lat}
    lng={poi.lng}
    photos={photos}
    photoIds={poi.pids}
  />
);

// translation layer for v3 POI format
export const POIv3 = ({ poi, photos }) => (
  <POI
    id={poi.id}
    poiType={poi.poiType}
    name={poi.name}
    description={poi.description}
    url={poi.url}
    lat={poi.lat}
    lng={poi.lng}
    photos={photos}
    photoIds={poi.photoIds}
  />
);

class Photogrid extends React.PureComponent {
  gallery = (activePhotoId) => {
    const { photos, pids } = this.props;
    const poiPhotos = pids.map((id) => photos.find((p) => p.id === id));
    showGallery({ photos: poiPhotos, activePhotoId, readonly: true });
  };

  render() {
    const { pids } = this.props;
    if (!pids) {
      return null;
    }
    return (
      <div className={styles.Photogrid}>
        {pids.map((id) => (
          <NativeClickImg key={id} src={photoMilli(id)} onClick={() => this.gallery(id)} />
        ))}
      </div>
    );
  }
}
